@if (isLoading) {
  <div class="spinner">
    <mat-card appearance="outlined">
      <mat-card-title>Chargement</mat-card-title>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </mat-card>
  </div>
}
@if (!isLoading && !error) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-title>Page de paiement</mat-card-title>
      <mat-card-content>
        <iframe class="iframe" [frameBorder]="0" [src]="srcIframe"></iframe>
      </mat-card-content>
    </mat-card>
  </div>
}
@if (error) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-title>Page de paiement</mat-card-title>
      <mat-card-content>
        {{errTxt}}
        @if (alertAgence) {
          <p>Merci de vous rapprocher de votre agence</p>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
